// Thin client for the mens-health backend. The backend then dispatches the
// outbound call to Alfred Voice — raw PII never leaves the server.
import { readAttribution } from './analytics.js';

// Edge sanitization for the search-term param. Server re-runs the full check.
function sanitizeTermEdge(raw) {
  if (raw == null) return undefined;
  const s = String(raw).trim();
  if (!s || s.length > 120) return undefined;
  if (/\b(?:\+?\d[\d\s.\-()]{7,}\d)\b/.test(s)) return undefined;
  if (/[^\s@]+@[^\s@]+\.[^\s@]+/.test(s)) return undefined;
  return s.toLowerCase();
}

export async function requestCallback({ personaId, pairId, phone, languageCode, callConsent, textConsent, consentAt, firstName, studyId }) {
  const attr = readAttribution();
  const res = await fetch('/api/callback', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      persona_id: personaId,
      // VitaMD pairs page sends the chosen duo; single-voice page omits it.
      pair_id: pairId || undefined,
      phone,
      language: languageCode,
      call_consent: !!callConsent,
      text_consent: !!textConsent,
      consent_at: consentAt || undefined,
      gclid: attr.gclid,
      campaign_id: attr.campaign_id || attr.utm_campaign,
      term: sanitizeTermEdge(attr.utm_term),
      first_name: firstName || undefined,
      study_id: studyId || undefined
    })
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Request failed (${res.status})`);
  }
  return res.json();
}
